module.exports = __webpack_public_path__ + "static/img/cCT1.8b6c87ad.png";